import styled from "styled-components"
import { FormGroup } from "client/components"


export const FormGroupStyled = styled(FormGroup)`
    width: calc(50% - 70px);
    padding: 5px 15px 0 15px;
    position: relative;
    margin: 0;
    
    &:after {
        content: "";
        display: block;
        position: absolute;
        height: 100%;
        width: 1px;
        right: 0;
        top: 0;
        background: dimgrey;
    }
`
export const RowStyled = styled.div<{
    danger?: boolean
    titleRow?: boolean
    top?: boolean
    bottom?: boolean
}>`
    display: flex;
    flex-direction: row;
    background: ${(props) => (props.danger ? props.theme.silUpdateDangerRowBackground : "transparent")};
    
    ${(props) => props.titleRow && `
        & > ${FormGroupStyled} {
            padding: 12px 15px 4px 15px;
        }
    `}
    
    ${(props) => props.top && `
        & > ${FormGroupStyled} {
            &:after {
                height: calc(100% - 5px);
                top: 5px;
            }
        }
    `}
    
    ${(props) => props.bottom && `
        & > ${FormGroupStyled} {
            &:after {
                height: calc(100% - 5px);
                top: 0;
            }
        }
    `}
`
export const ButtonWrapper = styled.div`
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
`
